module.exports = __webpack_public_path__ + "static/media/perfil-160x120.0d2c9a7a.jpg";